import React, { Component } from "react";
import { connect } from "react-redux";
import { View, Text, FlatList, TouchableOpacity } from "react-native";
import Colors from "@microdoing/shared/constants/Colors";
import { widthPercentageToDP as wp } from "react-native-responsive-screen";
import moment from "moment-timezone";
import i18n from "@microdoing/shared/i18n";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import { Header } from "../../components/common";
import OptionBar from "./OptionBar";
import NotificationsModal from "../ActionScreen/NotificationsModal";
import {
  clickTopic,
  submitLibraryFeedbackRequest,
  onChangeTopicFeedbackIdea,
} from "@microdoing/shared/services/library/actions";
import selectLanguage from "../../utils/selectLanguage";
import CommentBox from "../FeedbackScreen/CommentBox";
import InputScrollView from "react-native-input-scroll-view";
import theme from "app/Theme/Theme";

const options = [
  { value: 1, title: "goals-notification-option1" },
  { value: 2, title: "goals-notification-option2" },
  { value: 3, title: "goals-notification-option3" },
  { value: 5, title: "goals-notification-option4" },
];

class LibraryFeedback extends Component {
  // TODO à supprimer si searchScreen du dossier libraryfeedback est supprimé || à vérifier || supprimer son appel dans la navigation aussi
  state = {
    isNotificationModalVisible: false,
  };

  keyExtractor = (item, index) => {
    return index.toString();
  };

  displayDate = date => {
    const current = moment().startOf("day");
    // const today = moment();
    const doneDate = moment.tz(date, this.props.timezone);
    // const doneDate = moment(date);
    const hour = doneDate.format("HH:mm");
    const lastDate = doneDate.startOf("day");
    const diff = current.diff(lastDate, "days");
    if (diff === 0) {
      return i18n.t("today-at", { hour });
    } else if (diff === 1) {
      return i18n.t("yesterday-at", { hour });
    }
    return i18n.t("ago-at", { days: diff, hour });
  };

  goBack = () => {
    this.props.navigation.goBack();
  };

  getUserAnswer = () => {
    return this.props.poll.answers.find(
      el => el.user._id === this.props.userId,
    );
  };

  displayOption = userPaceGoal => {
    return options.map((el, i) => {
      return (
        <OptionBar
          onPress={this.pressOption(el.value)}
          isUserChoice={userPaceGoal === el.value}
          key={i}
          title={i18n.t(el.title)}
        />
      );
    });
  };

  triggerNotificationModal = async () => {
    this.setState({
      isNotificationModalVisible: !this.state.isNotificationModalVisible,
    });
  };

  submitFeedback = () => {
    const {
      userTopicChoices,
      topicFeedbackIdea,
      userId,
      clientId,
    } = this.props;
    this.props.submitLibraryFeedbackRequest({
      userId,
      clientId,
      topicChoices: userTopicChoices,
      topicIdea: topicFeedbackIdea,
    });
  };

  onChangeText = text => {
    this.props.onChangeTopicFeedbackIdea(text);
  };

  renderOption = data => {
    const option = data.item;
    return (
      <OptionBar
        onPress={() => this.props.clickTopic(option)}
        isUserChoice={
          this.props.userTopicChoices.findIndex(
            el => el.value === option.value,
          ) > -1
        }
        title={selectLanguage({
          text: option.title,
          language: this.props.language,
        })}
      />
    );
  };

  render() {
    return (
      <View style={styles.main}>
        <Header
          onPress={this.goBack}
          name={i18n.t("feedback-library")}
          style={{ borderBottomWidth: 0 }}
        />
        <NotificationsModal
          isVisible={this.state.isNotificationModalVisible}
          firstName={this.props.firstName}
          triggerModal={this.triggerNotificationModal}
        />
        <InputScrollView
          keyboardShouldPersistTaps="always"
          style={styles.scrollView}
          contentContainerStyle={{ paddingBottom: 100 }}
        >
          <Text style={styles.pollTitle}>
            {i18n.t("library-feedback-which-category")}
          </Text>
          <FlatList
            keyboardShouldPersistTaps="always"
            data={this.props.topicOptions}
            extraData={this.props.userTopicChoices}
            contentContainerStyle={styles.choiceView}
            horizontal={false}
            numColumns={2}
            keyExtractor={(item, index) => index}
            renderItem={this.renderOption}
          />
          <Text style={styles.answer}>{i18n.t("other-topic-in-mind")}</Text>
          <CommentBox
            props={this.props}
            style={{ alignSelf: "center" }}
            value={this.props.topicFeedbackIdea}
            onChangeText={this.onChangeText}
            placeholder={i18n.t("other-topic-in-mind")}
          />
          <TouchableOpacity
            disabled={this.props.userTopicChoices.length < 1}
            style={[
              styles.button,
              this.props.userTopicChoices.length < 1 && {
                borderColor: theme.colors["neutral.400"],
                backgroundColor: theme.colors["neutral.100"],
              },
            ]}
            onPress={this.submitFeedback}
          >
            <Text
              style={[
                styles.buttonText,
                this.props.userTopicChoices.length < 1 && {
                  color: theme.colors["neutral.400"],
                  fontWeight: "normal",
                },
              ]}
            >
              {i18n.t("validate-choices")}
            </Text>
          </TouchableOpacity>
          <View style={{ flex: 1 }} />
        </InputScrollView>
      </View>
    );
  }
}

const styles = {
  main: {
    flex: 1,
    alignItems: "center",
    backgroundColor: theme.colors["brand.500"],
    flexDirection: "column",
  },
  scrollView: {
    borderColor: theme.colors["neutral.white"],
    borderTopWidth: 1,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    backgroundColor: theme.colors["neutral.white"],
    flexDirection: "column",
  },
  pollTitle: {
    fontSize: wp("7%"),
    color: theme.colors["neutral.900"],
    fontWeight: "bold",
    marginTop: 15,
    marginLeft: 20,
    marginRight: 20,
  },
  text: {
    color: theme.colors["neutral.900"],
    fontSize: wp("4%"),
  },
  date: {
    color: Colors.dateBlue,
    marginTop: 4,
    fontSize: wp("3.2%"),
  },
  title: {
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 15,
    fontWeight: "bold",
    color: theme.colors["neutral.900"],
    fontSize: wp("4.5%"),
  },
  answer: {
    marginTop: 15,
    marginBottom: 5,
    marginLeft: 15,
    marginRight: 15,
    textAlign: "center",
    fontSize: wp("4%"),
    color: theme.colors["brand.500"],
    fontWeight: "bold",
  },
  choiceView: {
    paddingBottom: 10,
  },
  button: {
    marginTop: 10,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 25,
    paddingRight: 25,
    width: wp("80%"),
    borderRadius: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.colors["brand.500"],
  },
  buttonText: {
    fontSize: wp("5%"),
    color: theme.colors["neutral.white"],
    fontWeight: "bold",
  },
};

const mapStateToProps = state => {
  const { language } = state.profileSettings;
  const {
    userTopicChoices,
    topicFeedbackIdea,
    topicOptions,
    requesting,
  } = state.library;
  const clientId = state.user.client;
  return {
    userId: getUserId(state),
    clientId,
    userTopicChoices,
    topicFeedbackIdea,
    topicOptions,
    language,
    requesting,
  };
};

export default connect(mapStateToProps, {
  clickTopic,
  submitLibraryFeedbackRequest,
  onChangeTopicFeedbackIdea,
})(LibraryFeedback);
